import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { Wordmark } from "../components/Wordmark";
import { Seo } from "../components/Seo";

export default function Login() {
  const { login, user, ready } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (ready && user) navigate("/admin");
  }, [ready, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-sand-dark" data-testid="login-page">
      <Seo title="Studio Login" path="/login" noIndex />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md bg-sand border border-ink/10 p-10 md:p-12"
      >
        <Wordmark size="md" className="mb-6" />
        <h1 className="font-serif text-4xl tracking-tight text-ink mb-8">Studio Admin</h1>
        <form onSubmit={submit} className="space-y-4">
          <input
            data-testid="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="w-full bg-sand border border-ink/15 px-5 py-4 outline-none focus:border-forest transition-colors"
          />
          <input
            data-testid="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="w-full bg-sand border border-ink/15 px-5 py-4 outline-none focus:border-forest transition-colors"
          />
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-forest text-sand py-4 text-xs uppercase tracking-[0.2em] font-bold hover:bg-clay transition-colors duration-500 disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
